import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { ToastContainer } from 'react-toastify';
import FooterSection from "../Components/FooterSection";
import Header from "../Components/Header";
import PageTitleSection from "../Components/PageTitleSection";
import Spacer from "../Components/Spacer";
import HttpHelper from '../service/httpService';
import ReactPlayer from 'react-player'

const PageDynamic = () => {
    const location = useLocation();

    var slug = '';
    const [count, setCount] = useState(0);
    const [pageDetails, setPageDetails] = useState([]);
    const [pageTitle, setPagetitile] = useState('');
    const getPageData = (data) => {
        var newUrl = slug;
        if (slug) {
            if (slug.includes('/')) {
                newUrl = slug.replace('/', '');
            }
        }
        HttpHelper.get("website/page/" + newUrl, data).then((response) => {
            if (response.status === 200) {
                setPageDetails(() => {
                    return [{ ...response.data }];
                })
                setPagetitile(response.data.title);


            }
        })
    }

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        slug = urlParams.get('slug');
        getPageData();
        setCount(count + 1);

    }, [location])

    return (<>
        <ToastContainer />
        <Header />
        <PageTitleSection
            title={pageTitle}
            pagetitle={pageTitle}
        />

        <section className="section py-5 blackBg">
            <div className="container">
                {pageDetails && pageDetails.map((e, i) => {
                    return (<>
                        <div >
                            <h3>{e.description}</h3>
                            <div className=" col-md-12 text-right mb-10" >
                                {
                                    e.file != null ?
                                        (
                                            e.file.fileType == ".mp4" ?
                                                <ReactPlayer url={e.file != null ? e.file.fileUrl : ''} config={{ file: { attributes: { controlsList: 'nodownload', onContextMenu: e => e.preventDefault() } } }} width="100%" height="100%" controls={true} playing={true} muted={true} loop={true} />
                                                : <img src={e.file != null ? e.file.fileUrl : ''} style={{ height: '350px' }} />
                                        )
                                        : ''
                                }
                            </div>
                            <div className="col-md-12" dangerouslySetInnerHTML={{ __html: e.content }} key={i} ></div>
                        </div>
                    </>)
                })}
            </div >
        </section>
        <Spacer bgClass="blackBg" />
        <FooterSection />
    </>)
}

export default PageDynamic;